var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.05 0 0 7.05 326.5 243.5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.58 11.39)",
    id: "path2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint0_linear_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.57 0 0 0.57 0.99 -0.12)",
    x1: 53.973801,
    y1: 54.973999,
    x2: 94.163498,
    y2: 71.829498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(36,147,97)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(62,207,142)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.57177335,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint0_linear_5)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-47.58, -43.39)",
    d: "m 37.41219 62.936701 c -1.634985 2.05896 -4.950068 0.93085 -4.989463 -1.69817 L 31.846665 22.786035 h 25.855406 c 4.683108 0 7.294967 5.409033 4.382927 9.07673 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.58 11.39)",
    id: "path4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint1_linear_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.57 0 0 0.57 0.99 -0.12)",
    x1: 36.1558,
    y1: 30.577999,
    x2: 54.484402,
    y2: 65.080597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(0,0,0)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.57177335,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint1_linear_6)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-47.58, -43.39)",
    d: "m 37.41219 62.936701 c -1.634985 2.05896 -4.950068 0.93085 -4.989463 -1.69817 L 31.846665 22.786035 h 25.855406 c 4.683108 0 7.294967 5.409033 4.382927 9.07673 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.43 -11.39)",
    id: "path6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0.57177335,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(62,207,142)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16.57, -20.61)",
    d: "m 26.89694 1.0634102 c 1.634986 -2.05918508 4.950125 -0.93090008 4.989521 1.698149 L 32.138899 41.214003 H 6.607076 c -4.6832501 0 -7.29518376 -5.409032 -4.3830007 -9.07673 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/Supabase.1a06eb7548bce079e802d84fadf9a1a6.svg";
export { ForwardRef as ReactComponent };